import React from 'react';
import { IBox, Content } from './inspinia';
import * as c from '../helpers/constants'
import { callApi } from '../helpers/methods'
import { event } from 'jquery';

export default class TagSelectorHTML extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    hrefEmpty(){
    }

    getTags() {
        if (!this.state.comboTag) {
            return;
        }
        return this.state.comboTag.map(function (tag) {
            return (
                <a href={'TAGSELECTORHTML:' + tag.nome} className="d-block text-grey tag-selector" onClick={this.props.onClick}><strong>{tag.nome}</strong></a>
            );
        }.bind(this));

    }

    componentDidMount() {

        if (this.props.getCampanha) {
            let self = this;

            const url = `${c.API_CAMPAIGN_URL}/tagsOfCampaign/${this.props.getCampanha}`;
            const options =
            {
                method: 'GET'
                , headers: { 'Content-Type': 'application/json' }
            };

            callApi(url, options, function (response) {
                self.setState({ comboTag: response });
            });
        }
    }

    render() {
        const props = this.props;

        return (
            <IBox className="mb-0 text-left">
                <Content style={{ border: "solid 1px #dcdcdc", borderTop: "solid 4px #dcdcdc", maxHeight: "184px", overflowY: "auto" }}>
                    <span className="fs-14 fw-600 text-body">Tags:</span>

                    <div className="tags fs-12 fw-400" style={{ lineHeight: "26px", padding: "0px" }}>
                        {this.getTags()}
                    </div>
                </Content>
            </IBox>
        )
    }
}
